export default __webpack_public_path__ + "static/media/bagmadd.e1e370d5.jpg";